import { createSelector } from 'reselect';
import { DEFAULT_SECTION_ACCESS_TYPE, SECTION_ACCESS_TYPES } from '../utils/consts';
import { deriveSectionsAccess, getFeatureSectionsByLink, getNavigationSections } from './navigation';
import getCurrentPath from './routing';
import { getUserData, isUserAdNetwork, normalizeAccountTypeName } from './user';

const READ = 1;
const WRITE = 2;
const READ_WRITE = 3;
const FEATURE_GOALS = 'goals';

const FEATURE_LINK_ALIASES = {
    '/react/apps': ['/apps'],
};

const typesMap = {
    read: READ,
    write: WRITE,
    readWrite: READ_WRITE,
};

const ADNETWORK_MAP = {
    '/react/link-management': { permission: READ, isSingleAccessLevel: false },
    '/react/partner-config': { permission: READ, isSingleAccessLevel: false },
    '/react/apps': { permission: READ, isSingleAccessLevel: false },
};

const AGENCY_MAP = {
    '/react/singular-events': { permission: READ, isSingleAccessLevel: false },
    '/react/apps': { permission: READ, isSingleAccessLevel: false },
};

const ACCOUNT_TYPES_MAP = {
    ad_network: ADNETWORK_MAP,
    agency_account: AGENCY_MAP,
};

const getUserMap = createSelector([getUserData], userData => {
    const accountType = normalizeAccountTypeName(userData.account_type_name);
    return ACCOUNT_TYPES_MAP[accountType] || {};
});

const getCurrentPathAccess = createSelector(
    [getNavigationSections, getCurrentPath],
    (navigationSections, currentPath) => {
        if (!navigationSections) return DEFAULT_SECTION_ACCESS_TYPE;

        const linkCandidates = [currentPath.pathname, ...(FEATURE_LINK_ALIASES[currentPath.pathname] || [])];
        const sections =
            linkCandidates
            .map(pathname => getFeatureSectionsByLink(navigationSections, pathname))
            .find(featureSections => featureSections.length) || [];

        return deriveSectionsAccess(sections);
    }
);

export const getFeaturePermissions = createSelector(
    [getUserMap, getCurrentPath, getCurrentPathAccess],
    (userMap, currentPath, currentPathAccess) => {
        const defaultAccess = {
            permission: currentPathAccess?.accessType === SECTION_ACCESS_TYPES.VIEW ? READ : READ_WRITE,
            isSingleAccessLevel: currentPathAccess ? currentPathAccess.isSingleAccessLevel : true,
        };

        const { permission, isSingleAccessLevel } = userMap[currentPath.pathname] || defaultAccess;
        return {
            typesMap,
            permission,
            isSingleAccessLevel,
        };
    }
);

export const getReadOnly = createSelector([getFeaturePermissions], ({ permission }) => {
    return permission === READ;
});

export const isGoalsReportPermitted = createSelector([isUserAdNetwork, getUserData], (isAdNetwork, userData) => {
    return !isAdNetwork && userData.feature_flags?.includes(FEATURE_GOALS);
});
